var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, showOffMarketCta, ctaText } = options;
   let resource_id;
   if(property.status) {
     var status_text;
     var cta_text = "Contact a neighborhood expert";
     var leadFormTarget = '#pdp-contact-local-agent-modal';
     var omtag_cta = 'ldp:homes-near-street:contact-neighborhood-expert';
     var lat;
     var lon;
     if (property.position && property.position.coordinates) {
       lat = property.position.coordinates[1]
       lon = property.position.coordinates[0]
     } else if (property.lat && property.lon) {
       lat = property.lat;
       lon = property.lon;
     }
     if (property.status === "for_sale"){
       status_text = "For Sale";
       cta_text = ctaText == 'V1' ? 'Contact an Agent' : 'Contact Agent';
       leadFormTarget = `#homes-around-card-${property.mprId || property.property_id}`;
       omtag_cta = 'ldp:homes-near-street:contact-agent';
     }
     else if (property.status === "recently_sold") {
       status_text = "Sold";
     }
     else if (property.status === "off_market") {
       status_text = "Off Market";
     }
   }

__p+='\n\n';
 if(property) { 
__p+='\n<div class="component_property-card" data-ldpurl="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'" data-agentid="'+
((__t=( property.agent_id ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.mprId || property.property_id ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-omtag="'+
((__t=( `ldp:homes-around-address:card:${property.status}` ))==null?'':__t)+
'" data-status="'+
((__t=( property.dataStatus))==null?'':__t)+
'">\n  <a href="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'">\n    <div class="card-box js-navigate-to js-record-user-activity" data-url="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'">\n      <div class="label-wrap">\n        <span class="label label-dark-transparent display-inline-block margin-right" >'+
((__t=( status_text ))==null?'':__t)+
'</span>\n        ';
 if(property.search_flags.is_pending){ 
__p+='\n          <span class="label label-red display-inline-block" data-label="property-label-pending">Pending</span>\n        ';
 } else if(property.search_flags.is_contingent){ 
__p+='\n          <span class="label label-red display-inline-block" data-label="property-label-contingent">Contingent</span>\n        ';
 } else if(property.search_flags.is_new_listing){ 
__p+='\n          <span class="label label-green label-outline-none display-inline-block" data-label="property-label-new">New</span>\n        ';
 } 
__p+='\n      </div>\n\n    <div class="photo-wrap" data-label="property-photo">\n        ';
 if(property.photo){ 
__p+='\n          <img alt="'+
((__t=( property.address ))==null?'':__t)+
'" class="main-photo" itemprop="image" src="'+
((__t=( property.photo ))==null?'':__t)+
'">\n        ';
 } 
__p+='\n    </div>\n    <div class="detail-wrap">\n      <div class="photo-overlay">\n        <div class="price" data-label="property-price">\n          ';
 if (property.priceDisplay === "") { 
__p+='\n          <span class="data-price">No Estimate Available</span>\n          ';
 } else { 
__p+='\n          <span class="data-price">'+
((__t=( property.priceDisplay ))==null?'':__t)+
'</span>\n          ';
 } 
__p+='\n        </div>\n      </div>\n      <ul class="prop-meta ellipsis">\n        ';
 if(property.bed_display || property.bed){ 
__p+='\n        <li data-label="property-meta-beds">\n          <span class="data-value meta-beds">'+
((__t=( property.bed_display || property.bed ))==null?'':__t)+
'</span> bd</li>\n        ';
 } 
__p+='\n        ';
 if(property.bath){ 
__p+='\n        <li data-label="property-meta-baths"><span class="data-value">'+
((__t=( property.bath ))==null?'':__t)+
'</span> ba</li>\n        ';
 } 
__p+='\n        ';
 if(property.sqft_display && property.sqft_display != 0 && property.sqft_display != "0"
              && property.sqft_display != "0 - 0"){ 
__p+='\n        <li data-label="property-meta-sqft"><span class="data-value">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</span> sq ft </li>\n        ';
 } 
__p+='\n      </ul>\n      <div class="address ellipsis" data-label="property-address">\n        <a href="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'">\n          ';
 if(property.address) { 
__p+='\n          <span class="listing-street-address">'+
((__t=( property.address ))==null?'':__t)+
'</span>\n          ';
 } 
__p+='\n        </a>\n      </div>\n      ';
 if(property.status === 'for_sale' || showOffMarketCta === 'true' ) { 
__p+='\n        <div class="cta-wrap">\n          <a href="javascript:void(0)" class="js-open-private-modal cta-btn" data-title="Find out more about this property" data-omtag="'+
((__t=( omtag_cta ))==null?'':__t)+
'" data-placeholder="I would like more details about this property." data-toggle="modal"\n             data-target="'+
((__t=( leadFormTarget ))==null?'':__t)+
'" data-property-id="'+
((__t=( property.id || property.mprId || property.property_id ))==null?'':__t)+
'" data-listing-id="'+
((__t=( property.listing_id ))==null?'':__t)+
'"data-city="'+
((__t=( property.city ))==null?'':__t)+
'"\n             data-bed="'+
((__t=( property.bed ))==null?'':__t)+
'" data-bath="'+
((__t=( property.bath ))==null?'':__t)+
'" data-sqft="'+
((__t=( property.sqft ))==null?'':__t)+
'" data-price="'+
((__t=( property.price ))==null?'':__t)+
'" data-form-type="'+
((__t=( property.form_type ))==null?'':__t)+
'" data-lead-type="'+
((__t=( property.lead_type ))==null?'':__t)+
'"\n             data-show-contact-a-lender="'+
((__t=( property.show_contact_a_lender ))==null?'':__t)+
'" data-flip-the-market-enabled ="'+
((__t=( property.flip_the_market_enabled ))==null?'':__t)+
'" data-show-veterans-united="'+
((__t=( property.show_veterans_united ))==null?'':__t)+
'" data-sold-listing-diff="'+
((__t=( property.sold_price_to_listing_price_diff ))==null?'':__t)+
'" data-homes-around="true"\n             data-status="'+
((__t=( property.status ))==null?'':__t)+
'" data-proptype="'+
((__t=( property.propertyType ))==null?'':__t)+
'" data-lat="'+
((__t=( lat ))==null?'':__t)+
'" data-lon="'+
((__t=( lon ))==null?'':__t)+
'" data-photo="'+
((__t=( property.photo ))==null?'':__t)+
'"\n             data-state="'+
((__t=( property.state ))==null?'':__t)+
'" data-zip="'+
((__t=( property.zip ))==null?'':__t)+
'" data-address="'+
((__t=( property.address ))==null?'':__t)+
'">\n            '+
((__t=( cta_text ))==null?'':__t)+
'\n          </a>\n        </div>\n      ';
 } 
__p+='\n    </div>\n    ';
 if(property.status === 'for_sale') { 
__p+='\n      <div class="save-wrap">\n        <div class="js-tracking js-hns-save" data-status="'+
((__t=( property.status ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.mprId || property.property_id ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" >\n          ';
 if ($.cookie('REMEMBER_ME')) { 
__p+='\n            ';
 resource_id = property.saved_resource_id 
__p+='\n            ';
 if (resource_id) { 
__p+='\n              <a class="js-delete-listing btn-save-listing removeFromSaved hp-unsave" data-res-id="'+
((__t=( resource_id ))==null?'':__t)+
'" data-omtag=\'ldp:homes-around-address:listing_unsave\'>\n                <span class="ra-stack icon-save-lg">\n                  <i class="ra ra-heart-o ra-stack-2x pos-absolute"></i>\n                  <i class="ra ra-heart icon-save icon-save-sm pos-absolute"></i>\n                </span>\n              </a>\n              <a class="js-save-listing btn-save-listing addToSave hp-save" style="display:none" data-omtag=\'ldp:homes-around-address:listing_save\'>\n                <span class="ra-stack icon-save-lg">\n                  <i class="ra ra-heart ra-stack-1x pos-absolute js-no-listing-click"></i>\n                  <i class="ra ra-heart-o icon-save-sm pos-absolute js-no-listing-click"></i>\n                </span>\n              </a>\n            ';
 } else { 
__p+='\n              <a class="js-save-listing btn-save-listing addToSave hp-save" data-omtag=\'ldp:homes-around-address:listing_save\'>\n                  <span class="ra-stack icon-save-lg">\n                    <i class="ra ra-heart ra-stack-1x pos-absolute js-no-listing-click"></i>\n                    <i class="ra ra-heart-o icon-save-sm pos-absolute js-no-listing-click"></i>\n                  </span>\n              </a>\n              <a class="js-delete-listing btn-save-listing removeFromSaved hp-unsave" style="display:none" data-omtag=\'ldp:homes-around-address:listing_unsave\'>\n                <span class="ra-stack icon-save-lg">\n                  <i class="ra ra-heart-o pos-absolute ra-stack-2x"></i>\n                  <i class="ra ra-heart icon-save pos-absolute ra-stack-1x icon-save-sm"></i>\n                </span>\n              </a>\n            ';
 } 
__p+='\n          ';
 } else { 
__p+='\n            <a class="js-save-listing btn-save-listing hp-save-not-logged-in" title="Save" href="#" data-omtag=\'ldp:homes-around-address:listing_save\'>\n              <span class="ra-stack icon-save-lg">\n                <i class="ra ra-heart ra-stack-1x pos-absolute js-no-listing-click"></i>\n                <i class="ra ra-heart-o pos-absolute icon-save-sm"></i>\n              </span>\n            </a>\n          ';
 } 
__p+='\n        </div>\n      </div>\n    ';
 } 
__p+='\n  </div>\n  <div>\n    ';
 if(property.status === 'for_sale') { 
__p+='\n      <div class= "homes-around-more-info">\n         <h3 class="text-center">'+
((__t=( property.days_on_market ))==null?'':__t)+
'</h3>\n         <div class="color-gray text-center font-size-small"> Days On Market </div>\n      </div>\n      ';
 } else if(property.status === 'recently_sold') { 
__p+='\n        ';
 if(property.sold_price_difference_summary) { 
__p+='\n          <div class= "homes-around-more-info">\n            <h3 class="text-center"><i class="ra '+
((__t=( property.sold_price_difference_summary.is_lower ? "ra-arrow-down" : "ra-arrow-up"))==null?'':__t)+
'"> </i>'+
((__t=( property.sold_price_difference_summary.price_display ))==null?'':__t)+
'</h3>\n            <div class="color-gray text-center font-size-small">'+
((__t=( property.sold_price_difference_summary.is_lower ? 'Sold Below Asking' : 'Sold Above Asking' ))==null?'':__t)+
'</div>\n          </div>\n        ';
 } else { 
__p+='\n          <div class= "homes-around-more-info">\n            <h3 class="text-center">'+
((__t=( property.last_sold_date_display || '-' ))==null?'':__t)+
'</h3>\n            <div class="color-gray text-center font-size-small">Sold Date</div>\n          </div>\n        ';
 } 
__p+='\n      ';
 } else { 
__p+='\n        ';
 if(property.last_sold_price_display) { 
__p+='\n          <div class= "homes-around-more-info">\n            <h3 class="text-center">'+
((__t=( property.last_sold_price_display ))==null?'':__t)+
'</h3>\n            <div class="color-gray text-center font-size-small">Sold Price</div>\n          </div>\n        ';
 } else { 
__p+='\n          <div class= "homes-around-more-info">\n            <h3 class="text-center">'+
((__t=( property.last_sold_date_display || '-' ))==null?'':__t)+
'</h3>\n            <div class="color-gray text-center font-size-small">Sold Date</div>\n          </div>\n        ';
 } 
__p+='\n    ';
 } 
__p+='\n  </div>\n  </a>\n</div>\n';
}
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/homes_around_card.jst.ejs